import type { LoginResult } from '../types';
import { getAuthenticatedDestination, type AuthenticatedDestination } from './profileCompletion';

export type LoginNavigationTarget = AuthenticatedDestination | '/auth/mfa-verify';

export function getLoginNavigationTarget(result: LoginResult): LoginNavigationTarget {
  if (result.kind === 'mfa_required') {
    return '/auth/mfa-verify';
  }
  return getAuthenticatedDestination(result.user);
}
